import React from 'react'
import { buildCloudinaryImageUrl } from '../../../utils/CloudinaryImageUrl';

function Header({ classContainer, classImg }) {
   let logo = localStorage.getItem('logo');

   if(localStorage.getItem !== undefined || localStorage.getItem !== null || localStorage.getItem !== "" ){
      let businessLogo=JSON.parse(localStorage.getItem('businessConfig'))
     if (businessLogo !== undefined || businessLogo !== null) {
      //logo = businessLogo.logo
   }
     
   }

   return (
      <>
         <div className={classContainer}>
            <img src={buildCloudinaryImageUrl({ url: logo, width: 300, quality: "auto", type: "image" }) || undefined} 
            className={classImg + " rounded mt-1"} alt="Logo SmartPay"
            loading='lazy' />
         </div>         
      </>
   )
}

export default Header